import { createSelector } from 'reselect';

import { editorSelector } from 'modules/v2/editor/store/selectors/editor';

import { getResetState, getResetSectionState } from './utils';

export const resetStateSelector = createSelector(editorSelector, getResetState);
export const resetSectionStateSelector = createSelector(editorSelector, getResetSectionState);
